<template>
  <div>
    <dialog-panel
      title="公司注册"
      :dialogController="companyBoard"
      width="600px"
      :loading="btnLoading"
      @cancel="closecompanyBoard"
      @confirm="confirmcompanyBoard"
    >
      <el-form :model="form" ref="form" label-width="100px" size="medium">
        <el-divider content-position="left">公司信息：</el-divider>
        <el-form-item label="企业名称" class="is-required">
          <el-input v-model="form.companyName" placeholder="企业名称"></el-input>
        </el-form-item>
        <!-- <el-form-item label="所属行业" class="is-required">
          <el-input v-model="form.industryType" placeholder="所属行业"></el-input> -->
          <!-- <el-select v-model="form.INDUSTRY_TYPE" multiple placeholder="所属行业" style="width:100%">
            <el-option
              v-for="item in selectOptions.INDUSTRY_TYPE"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select> -->
        <!-- </el-form-item> -->
        <el-form-item label="人员规模" class="is-required">
          <!-- <el-input v-model="form.staffSize" placeholder="人员规模"></el-input> -->
          <el-select v-model="form.staffSize" placeholder="人员规模" style="width:100%">
            <el-option
              v-for="item in selectOptions.STAFF_SIZE"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-divider content-position="left">管理员信息：</el-divider>
        <el-form-item label="管理员姓名" class="is-required">
          <el-input v-model="form.adminName" placeholder="管理员姓名"></el-input>
        </el-form-item>
        <el-form-item label="管理员手机" class="is-required">
          <el-input
            style="text-align:left;margin-bottom: 8px;"
            placeholder="请输入手机号"
            oninput="value=value.replace(/[^\d]/g,'')"
            v-model="form.adminMobile"
          ></el-input>
        </el-form-item>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="短信验证码" class="is-required">
              <el-input v-model="form.captcha" placeholder="短信验证码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item>
              <el-button :disabled="sendAuthCode" @click.native="getAuthCode">获取验证码{{auth_time}}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </dialog-panel>

    <div hidden="true" class="login_box">
      <div class="login_form">
        <div class="MainHead textTitle">注册公司信息</div>
        <br />
        <div>
          <div>
            <span class="flotleft">公司名称：</span>
            <el-input
              class="flotleft"
              style="width:300px;text-align:left"
              size="mini"
              placeholder="填写公司名称"
              v-model="form.txtName"
            ></el-input>
          </div>
          <br />
          <div>
            <span class="flotleft">手机号码：</span>
            <el-input
              style="width:300px;text-align:left;margin-bottom: 8px;"
              size="mini"
              placeholder="请输入手机号"
              oninput="value=value.replace(/[^\d]/g,'')"
              v-model="form.adminMobile"
            ></el-input>
          </div>
          <div style="text-align:left;" class="flotleft">
            <span class="flotleft">公司logo：</span>
            <el-image style="width: 50px; height: 50px" :src="src"></el-image>
          </div>
          <br />
          <div>
            <span class="flotleft">公司简介：</span>
            <el-input
              style="width:300px;text-align:left"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 8}"
              placeholder="请输入公司简介"
              v-model="form.txtBrief"
            ></el-input>
          </div>
          <br />
          <div class="textTitle">
            <el-button
              :loading="btnLoading"
              type="primary"
              @click="submitForm"
              v-preventReClick
            >提交审核</el-button>
            <el-button @click="refresh">重置</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { register, getCaptcha, dictGet } from "./loginAPI";
import * as _ from "utils/validate";

export default {
  data () {
    return {
      form: {},
      companyBoard: false,
      auth_time: '',
      sendAuthCode: false,
      src: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
      btnLoading: false,
      selectOptions:{
        STAFF_SIZE:[
          {id:'0-20人',name:'0-20人'},
          {id:'20-99人',name:'20-99人'},
          {id:'100-499人',name:'100-499人'},
          {id:'500-999人',name:'500-999人'},
          {id:'1000-9999人',name:'1000-9999人'},
          {id:'10000人以上',name:'10000人以上'}
        ],
        INDUSTRY_TYPE:[]
      }
    }
  },
  created () {
    // this.getDictItem()
  },
  computed: {
  },
  methods: {
    closecompanyBoard () {
      this.companyBoard = false
    },
    confirmcompanyBoard () {
      let f = {
        ...this.form
      };
      if (_.validNString(f.companyName)) {
        this.$message.error("企业名称是必填的");
        return;
      }
      // if (_.validNString(f.industryType)) {
      //   this.$message.error("所属行业是必填的");
      //   return;
      // }
      if (_.validNString(f.staffSize)) {
        this.$message.error("人员规模是必填的");
        return;
      }
      if (_.validNString(f.adminName)) {
        this.$message.error("管理员姓名是必填的");
        return;
      }
      if (_.validNString(f.adminMobile)) {
        this.$message.error("管理员手机是必填的");
        return;
      }
      if (_.validNString(f.captcha)) {
        this.$message.error("短信验证码是必填的");
        return;
      }
      this.btnLoading = true
      register(f).then(res => {
        if (res.code === 1000) {
          this.$message.success("提交成功！正在审核中！");
          this.btnLoading = false
          this.refresh()
          // setTimeout(() => {
          //   this.quit();
          // }, 5000);
        } else {
          this.companyBoard = false;
        }
      }).finally(err => {
        this.companyBoard = false;
        this.btnLoading = false
      })
    },
    show () {
      this.companyBoard = true
    },
    getAuthCode () {
      if (!_.validPhone(this.form.adminMobile)) {
        this.$message.error('请输入正确的手机号码')
        return
      }
      let dataPara = {
        mobile: this.form.adminMobile,
        type: 2
      }
      getCaptcha(dataPara)
        .then(res => {
          this.sendAuthCode = true // 禁用
          // 设置倒计时秒
          this.auth_time = 180
          var authTimeTimer = setInterval(() => {
            this.auth_time--
            if (this.auth_time <= 0) {
              this.auth_time = ''
              this.sendAuthCode = false // 启用
              clearInterval(authTimeTimer)
            }
          }, 1000)
        })
    },

    submitForm () {
      if (!this.form.txtName) {
        this.$message.error('请输入公司名称')
        return
      }
      if (!this.form.txtPhone) {
        this.$message.error('请输入手机号码')
        return
      }
      this.$message({
        showClose: true,
        message: '提交成功！正在审核中，请耐心等待！',
        type: 'success'
      });
    },
    refresh () {
      this.$options.data();
      // 重置数据
      this.$data = this.$options.data();   // nice
      // 如果有报错
      // 避免替换实例根$data。而是使用嵌套数据属性。
      Object.assign(this.$data, this.$options.data())
    },
    getDictItem () {
      //查询数据字典
      //所属行业Code
      let params = {
        dictGroupCodeList: "STAFF_SIZE,INDUSTRY_TYPE"
      };
      dictGet(params).then(res => {
        this.selectOptions.STAFF_SIZE = res.data.STAFF_SIZE;
        this.selectOptions.INDUSTRY_TYPE = res.data.INDUSTRY_TYPE;
      });
    },
  }
}
</script>
<style scoped>
.login_box {
  /* border: 1px solid #dcdfe6; */
  width: 600px;
  margin: 180px auto;
  padding: 65px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  -webkit-border-radius: 20px;
  box-shadow: 0 0 25px #dcdee2;
}
.login_form {
  padding-top: 1%;
  padding-left: 20%;
  padding-right: 10%;
}
.textTitle {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/login/companyRegister.vue